import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { useWishlist } from "../context/WishlistContext";
import { Heart, Trash2, ArrowRight } from "lucide-react";

export default function Wishlist() {
  const { items, remove, clear } = useWishlist();

  return (
    <div className="min-h-screen bg-[color:var(--dms-cream)]">
      <Navbar />
      <section className="max-w-7xl mx-auto px-5 lg:px-8 py-16">
        <div className="flex items-end justify-between flex-wrap gap-4">
          <div>
            <p className="kicker">Your wishlist</p>
            <h1 className="font-serif text-4xl md:text-5xl text-[color:var(--dms-navy)] mt-3">Saved for later</h1>
            <div className="w-14 h-[2px] bg-[color:var(--dms-peach)] mt-5" />
          </div>
          {items.length > 0 && <button onClick={clear} className="text-sm text-[color:var(--dms-navy)]/60 hover:text-[color:var(--dms-navy)]">Clear all</button>}
        </div>

        {items.length === 0 ? (
          <div className="mt-16 bg-white rounded-2xl border border-[color:var(--dms-navy)]/10 p-16 text-center">
            <div className="w-14 h-14 rounded-full bg-[color:var(--dms-peach-light)]/60 mx-auto flex items-center justify-center">
              <Heart className="w-6 h-6 text-[color:var(--dms-navy)]" />
            </div>
            <p className="mt-5 font-serif text-2xl text-[color:var(--dms-navy)]">Nothing saved yet</p>
            <p className="mt-2 text-sm text-[color:var(--dms-navy)]/60">Tap the heart on any product to save it here for later.</p>
            <Link to="/t-shirts" className="btn-peach mt-8 inline-flex">Browse shirts <ArrowRight className="w-4 h-4" /></Link>
          </div>
        ) : (
          <div className="mt-10 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
            {items.map((it) => (
              <div key={it.slug} className="group bg-white rounded-2xl overflow-hidden border border-[color:var(--dms-navy)]/5 hover-lift relative">
                <button onClick={() => remove(it.slug)} className="absolute top-3 right-3 z-10 w-9 h-9 rounded-full bg-white/90 backdrop-blur border border-[color:var(--dms-navy)]/10 flex items-center justify-center text-[color:var(--dms-navy)]/60 hover:text-red-600 transition-colors" aria-label="Remove">
                  <Trash2 className="w-4 h-4" />
                </button>
                <Link to={`/shop/${it.slug}`} className="block">
                  <div className="aspect-square overflow-hidden bg-[color:var(--dms-peach-light)]/40">
                    <img src={it.img} alt={it.title} className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105" />
                  </div>
                  <div className="p-5">
                    <p className="kicker text-[10px]">{it.category}</p>
                    <h3 className="font-serif text-lg mt-2 text-[color:var(--dms-navy)] leading-snug line-clamp-2">{it.title}</h3>
                    <p className="mt-3 font-serif text-xl text-[color:var(--dms-navy)]">{it.price}</p>
                  </div>
                </Link>
              </div>
            ))}
          </div>
        )}
      </section>
      <Footer />
    </div>
  );
}
